import type { Theme } from '@mui/material/styles';
import { useTheme } from '@mui/material/styles';
import type { ComponentType } from 'react';
import {
  IconChecked,
  IconCheckedDisabled,
  IconIndeterminate,
  IconIndeterminateDisabled,
  IconUnchecked,
  IconUncheckedDisabled,
} from './icons';

export type AppearanceProps = {
  isChecked: boolean;
  isDisabled: boolean;
  isIndeterminate: boolean;
  isError: boolean;
  readOnly?: boolean;
};

export const CheckboxAppearance: ComponentType<AppearanceProps> = ({
  isChecked,
  isDisabled,
  isIndeterminate,
  isError,
}) => {
  const useDefaultIcons = isError && !isDisabled;

  const theme = useTheme<Theme>();

  if (isIndeterminate) {
    if (useDefaultIcons) {
      return null;
    }
    return isDisabled ? <IconIndeterminateDisabled /> : <IconIndeterminate />;
  }

  if (isChecked) {
    return isDisabled ? <IconCheckedDisabled /> : <IconChecked isError={isError} />;
  }

  if (!isChecked) {
    if (useDefaultIcons) {
      return null;
    }

    return isDisabled ? (
      <IconUncheckedDisabled />
    ) : (
      <IconUnchecked color={isError ? theme.palette.error.main : theme.palette.divider} />
    );
  }

  return null;
};
